// The appetised {a} loading placeholder — animated mark + progress bar + label.
// Styles live in index.css (.ap-loading*). Used for the full-screen auth load
// and the inbox content load.
export function AppLoading({ label = "Loading your inbox" }: { label?: string }) {
  return (
    <div className="ap-loading">
      <span className="ap-loading__mark" aria-hidden="true">
        <span>{"{"}</span><span>a</span><span>{"}"}</span>
      </span>
      <div className="ap-loading__bar" aria-hidden="true"><i /></div>
      <div className="ap-loading__label" role="status">{label}</div>
    </div>
  );
}
